import { render, staticRenderFns } from "./ManageAthleteCard.vue?vue&type=template&id=c9c135b2&scoped=true&"
import script from "./ManageAthleteCard.vue?vue&type=script&lang=ts&"
export * from "./ManageAthleteCard.vue?vue&type=script&lang=ts&"
import style0 from "./ManageAthleteCard.vue?vue&type=style&index=0&id=c9c135b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c135b2",
  null
  
)

export default component.exports